module.exports = __webpack_public_path__ + "static/bandera-usa-b0bc7db9480b50549d8da550a45b6f25.svg";